import { createFileRoute } from "@tanstack/react-router";
import { UxHome } from "@/pages/3d/ux/UxHome";

export const Route = createFileRoute("/demo/3d/ux/")({
  component: UxHome,
});
